import React, {Component} from 'react';
import { observable, action } from 'mobx';
import { observer, inject } from 'mobx-react';
import { toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

import './style.scss'

import PageTitle from "../../../components/common/PageTitle";
import FeatherIcon from 'feather-icons-react';

import {reactLocalStorage as Storage} from "reactjs-localstorage";
import {Button, FormInput, InputGroup} from "shards-react";
import moment from "moment/moment";


let model = {
  store: {
    name: '',
    domain: '',
    baseDomain: '',
    logo: '',
    platform: '',
    platformId: '',
    addrMain: '',
    addrSub: '',
    presidentName: '',
    tel: '',
    email: '',
    notificationEmail: '',
    customerService: {},
    privacyOfficer: {},
    pTeamUser_id: ''
  }
}

// model.store = {
//   name: '온노마드',
//   domain: 'http://onnomad.co.kr/',
//   logo: '',
//   platform: 'nhn_godo',
//   platformId: '',
//   addrMain: '서울시 성동구 상원1길 25 ',
//   addrSub: '4160호 (주)온노마드',
//   presidentName: '윤정진',
//   tel: '02-6417-7000',
//   email: '',
//   notificationEmail: 'godrium@naver.com',
//   customerService: {},
//   privacyOfficer: {},
//   pTeamUser_id: ''
// }

@inject(({ common }) => ({ setIsShowPopup: common.setIsShowPopup, isShowModal: common.isShowModal, getIsShowPopup: common.getIsShowPopup, updateDoc: common.updateDoc  }))
@inject(({ teamUser }) => ({ isLogin: teamUser.isLogin, me:teamUser.me, getTeamUserList: teamUser.getTeamUserList, delTeamUser:teamUser.delTeamUser }))
@inject(({ company }) => ({ updateStore:company.updateStore, applyDelStoreAccount : company.applyDelStoreAccount  }))

@observer
class CompanyInfoEdit extends Component {

  //basic
  @observable store = {};

  @observable teamUser = {};
  @observable permissions = {}
  // @observable company = {};
  @observable isLogin = false;
  @observable isLoading = true;
  @observable urlParams = new URLSearchParams(window.location.search);

  @observable listParams = {page:1, limit:5};
  @observable boardList = [];
  @observable isRefreshing = false;

  constructor(props) {
    super(props);
    this.init()

    if(this.props.isLogin) {
      this.isLogin = this.props.isLogin;
      this.teamUser = this.props.me;
      this.teamUser.email = this.teamUser.email ? this.teamUser.email : this.teamUser.emailId;
      this.store = this.props.me.store ? this.props.me.store : {};
      console.log(this.store.isApplyDelStoreAccount)
      this.store.useExpiryDateDiffNow = moment(moment(this.store.useExpiryDate).format('YYYY-MM-DD')).diff(moment(), 'days')+1;
      this.permissions = this.props.me.permissions;
    }
    else {

      if(Storage.get('token')) {


      }
    }


    this.onChangeValue = this.onChangeValue.bind(this);
    this.onSubmit = this.onSubmit.bind(this);
    this.delTeamUser = this.delTeamUser.bind(this);
    this.updateStore = this.updateStore.bind(this);
    this.getTeamUserList = this.getTeamUserList.bind(this);
  }


  componentDidUpdate(prevProps, prevState){

  }

  @action
  init = async (key) => {

    if(this.props.isLogin) {
      this.isLogin = this.props.isLogin;
      this.teamUser = this.props.me;
      this.teamUser.email = this.teamUser.email ? this.teamUser.email : this.teamUser.emailId;
      this.store = this.props.me.store ? this.props.me.store : model.store;
      this.listParams.store_id = this.store._id;


      this.permissions = this.props.me.permissions;
      if(this.teamUser.isSuper && this.listParams.store_id) {
        //this.getTeamUserList();
      }
    }
    else {

      if(Storage.get('token')) {
        //todo 재확인 - 로그인 후 해당 페이지로 넘어 오는 경우 authCheck() 함수 미샐행 할 수 있게.
        //this.props.authCheck();
      }
      // else {
      //   window.location.replace('signIn');
      // }

    }
  };

  @action
  getTeamUserList =async() => {
    this.boardList = await this.props.getTeamUserList(this.listParams);
  };


  onChangeValue = async (event) => {
    const { name, value } = event.target;
    this.store[name] = value;
  };

  onChangeSearchValue = async (event, obj) => {
    const { name, value, type } = event.target;
    let newValue;
    if(type === 'checkbox') {
      if(value) {
        newValue = !JSON.parse(value);
      }
      else {
        newValue = true;
      }
    }
    else {
      newValue = value;
    }

    if(obj) {
      obj[name] = newValue;

      if(name === 'all') {
        for(let key in obj) {
          obj[key] = newValue;
        }
      }
      else {
        let isAll = false;
        if(newValue) {
          isAll = true;
          for(let key in obj) {
            if(!obj[key] && key !== 'all') {
              isAll = false;
              break;
            }
          }
        }
        obj['all'] = isAll;
      }
    }
    else {
      this.searchFormValue[name] = newValue;
      if(name === 'isDelete') {
        for(let key in this.searchFormValue.reviewDis) {
          this.searchFormValue.reviewDis[key] = !newValue;
        }
      }
    }

  };

  updateStore = async (event) => {
    this.props.updateStore(this.store, function(res) {
      if(res.errors && res.errors.length > 0) {
        alert(res.errors[0].message);
      }
      else {
        alert('수정되었습니다.');
        //_this.props.history.push('/reviewWriteConfig');
        //_this.isEditPassword = false;
      }

    });
  };

  onSubmit = async (event) => {
    event.preventDefault();
    this.updateStore(event)
    ///????
    //this.withdrawal = this.withdrawal.bind(this);
  };

  // 카페24 GET /api/v2/admin/store 호출 → Store 필드 갱신
  @action
  refreshFromCafe24 = () => {
    if (!this.store || !this.store._id) return;
    if (this.isRefreshing) return;
    this.isRefreshing = true;
    this.props.updateDoc('refreshCafe24Store', {store_id: this.store._id}, (res, errors) => {
      this.isRefreshing = false;
      if (errors && errors.length > 0) {
        toast.error(errors[0].message || '카페24 쇼핑몰 정보 갱신에 실패했습니다.');
        return;
      }
      if (res && res.data && typeof res.data === 'object') {
        Object.assign(this.store, res.data);
        toast.success('카페24 쇼핑몰 정보를 갱신했습니다.');
      } else {
        toast.warn('갱신 결과가 비어있습니다.');
      }
    });
  };

  delTeamUser = async (id, password) => {
    let _this = this;
    let confirm = window.confirm('삭제하시면 해당 회원은 탈퇴처리 됩니다. 진행하시겠습니까?');
    if(confirm) {
      let delTeamUser = {
        id : id,
        password: password,
      }
      this.props.delTeamUser(delTeamUser, function() {
        _this.getTeamUserList();
      });
    }
  };

  applyDelStoreAccount = async () => {
    let _this = this;
    let useExpiryDate = moment(this.store.useExpiryDate).format('YYYY년 MM월 DD일');
    let useExpiryDateDiff = Math.abs(this.store.useExpiryDateDiffNow);

    let confirm1;
    if(!this.store.useExpiryDate) {
      confirm1 = window.confirm('현재 계정은 매달 10회 자동 답글 작성 혜택을 받고 계십니다. 그래도 서비스를 탈퇴를 신청하시겠습니까?');
    }
    else {
      confirm1 = window.confirm(useExpiryDate + '까지 '+useExpiryDateDiff+'일 동안 정상적으로 사용이 가능합니다. 그래도 서비스를 탈퇴를 신청하시겠습니까?');
    }
    if(confirm1) {
      let confirm2;
      confirm2 = window.prompt("탈퇴를 원하시면 이메일 "+this.store.email+" 을 하단에 입력해 주세요.");
      if(confirm2 === this.store.email) {
        let applyDelStore = {
          id : this.store._id,
          teamUser_id: this.teamUser._id,
        }
        // console.log(applyDelStore)
        this.props.applyDelStoreAccount(applyDelStore, function() {
          _this.store.isApplyDelStoreAccount = true;
          toast("탈퇴신청이 완료 되었습니다. 남은 서비스 기간 동안 한 번 더 고민해보시고, 우리 서비스를 계속 이용해 주실 것을 부탁드립니다.");
        });

      }
      else {
        toast("탈퇴신청이 취소 되었습니다. 이메일을 정확하게 입력해 주세요.");
      }
    }
    else {
      toast("탈퇴 신청을 취소해 주셔서 감사합니다. 고객님의 신뢰에 부응할 수 있도록 더 좋은 서비스 제공을 위해 최선을 다하겠습니다. 앞으로도 언제든지 의견이나 건의사항이 있으시면 말씀해 주세요. 여러분의 소중한 피드백이 저희 서비스를 더욱 발전시키는 데 큰 도움이 됩니다.");
    }
  };

  reUseAccount = async () => {
    let _this = this;
    let applyDelStore = {
      id : this.store._id,
      teamUser_id: this.teamUser._id,
      isRecover: true
    }
    this.props.applyDelStoreAccount(applyDelStore, function() {
      _this.store.isApplyDelStoreAccount = false;
      toast("서비스를 다시 이용해 주셔서 감사합니다.");
    });
  };

  render() {


    return (
      <div className="main-content">
        <PageTitle />

        {/*{this.boardList && this.boardList.docs && this.boardList.docs.length > 0 ?*/}
        {/*<div className="section-box basic-info-table">*/}
        {/*  <div className="section-tit">*/}
        {/*    <h3>팀원 정보</h3>*/}
        {/*  </div>*/}
        {/*  <div className="section-box">*/}
        {/*    <table>*/}
        {/*      <tbody>*/}
        {/*      {this.boardList.docs.map((item, i) => (*/}
        {/*          <tr key={i}>*/}
        {/*            <td>{i+1}</td>*/}
        {/*            <td>{item.name}({item.emailId})</td>*/}
        {/*            <td>{item.email || item.emailId}</td>*/}
        {/*            <td>{item.tel}</td>*/}
        {/*            <td>{item.createdAt}</td>*/}
        {/*            {(true) && <td>{!item.isSuper && <span onClick={e => this.delTeamUser(item._id, item.password)}>삭제</span>}</td>}*/}
        {/*          </tr>*/}
        {/*        ))}*/}
        {/*      </tbody>*/}
        {/*    </table>*/}
        {/*  </div>*/}
        {/*</div> : null}*/}

        {( this.isLogin && this.teamUser.emailId ) ?
          <div className="write-post-box">
              <form onSubmit={e => this.onSubmit(e)}>
                <div className="section-box basic-info-table">
                  <div className="section-tit" style={{display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start', flexWrap: 'wrap', gap: 8}}>
                    <div>
                      <h3><FeatherIcon icon="briefcase" size="18" className="section-icon"/> 쇼핑몰 정보</h3>
                      <p className="section-desc">쇼핑몰 기본 정보를 관리합니다.</p>
                    </div>
                    <Button size="sm" theme="light" type="button"
                            onClick={this.refreshFromCafe24}
                            disabled={this.isRefreshing}
                            title="카페24의 최신 쇼핑몰 정보로 갱신합니다.">
                      <FeatherIcon icon="refresh-cw" size="13" style={{verticalAlign: 'middle', marginRight: 4}}/>
                      {this.isRefreshing ? '갱신 중...' : '카페24에서 갱신하기'}
                    </Button>
                  </div>
                  <table>
                    <tbody>
                    <tr>
                      <th>쇼핑몰 이름</th>
                      <td>
                        <InputGroup>
                          <FormInput name="name" placeholder="발송될 문자 또는 리뷰서비스에 표시될 서비스/ 쇼핑몰 / 브랜드의 이름입니다." disabled='disabled' value={this.store.name} onChange={event => {this.onChangeValue(event)}} className="table-input-text" />
                        </InputGroup>
                      </td>
                    </tr>
                    <tr className="info-id">
                      <th>기본 제공 도메인</th>
                      <td>
                        <InputGroup>
                          <FormInput name="baseDomain" placeholder="예: shopid.cafe24.com" disabled='disabled' value={this.store.baseDomain || ''} onChange={event => {this.onChangeValue(event)}} className="table-input-text" />
                        </InputGroup>
                      </td>
                    </tr>
                    <tr className="info-id">
                      <th>대표 도메인</th>
                      <td>
                        <InputGroup>
                          <FormInput name="domain" placeholder="대표 도메인을 입력해 주세요." value={this.store.domain || ''} onChange={event => {this.onChangeValue(event)}} className="table-input-text" />
                        </InputGroup>
                      </td>
                    </tr>
                    {/*<tr className="info-id">*/}
                    {/*  <th>플랫폼</th>*/}
                    {/*  <td>*/}
                    {/*    <FormSelect name="platform" value={this.store.platform} className="search-type" disabled >*/}
                    {/*      <option value="cafe24">카페24</option>*/}
                    {/*      <option value="nhn_godo">NHN커머스 고도</option>*/}
                    {/*    </FormSelect>*/}
                    {/*  </td>*/}
                    {/*</tr>*/}
                    {/*<tr>*/}
                    {/*  <th>로고</th>*/}
                    {/*  <td>*/}
                    {/*    <div className="logo-upload">*/}
                    {/*      <>*/}
                    {/*        <img src={this.store.logo ? this.store.logo : noImg} alt={this.store.name}*/}
                    {/*             style={{width: '120px', height: '80px', border: '1px solid #CED4DA'}}/>*/}
                    {/*      </>*/}
                    {/*      <button className="btn-table btn-img-upload">다시 업로드</button>*/}
                    {/*    </div>*/}
                    {/*    <p className="guide-text">150KB 이하, 120px * 60px 권장</p>*/}
                    {/*  </td>*/}
                    {/*</tr>*/}
                    <tr className="info-id">
                      <th>회사 전화번호</th>
                      <td>
                        <InputGroup>
                          <FormInput name="tel" placeholder="회사 전화번호를 입력해 주세요." value={this.store.tel} onChange={event => {this.onChangeValue(event)}} className="table-input-text" />
                        </InputGroup>
                      </td>
                    </tr>
                    <tr className="info-id">
                      <th>회사 대표 이메일</th>
                      <td>
                        <InputGroup>
                          <FormInput name="notificationEmail" placeholder="공지나 전달사항을 받을 대표 이메일을 입력해 주세요." value={this.store.notificationEmail} onChange={event => {this.onChangeValue(event)}} className="table-input-text" />
                        </InputGroup>
                      </td>
                    </tr>
                    {/*<tr className="info-id">*/}
                    {/*  <th>시크릿 코드</th>*/}
                    {/*  <td><p>{this.store.clientSecret}</p></td>*/}
                    {/*</tr>*/}
                    {/*<tr className="info-id">*/}
                    {/*  <th>쇼핑몰(회사) 소개</th>*/}
                    {/*  <td>*/}
                    {/*    <textarea name="about" type="text" className="table-input-text" value={this.store.about || ''}*/}
                    {/*              onChange={e => this.onChangeValue(e)}></textarea>*/}
                    {/*  </td>*/}
                    {/*</tr>*/}
                    </tbody>
                  </table>
                </div>

                <div className="section-save-area">
                  <Button type="submit" className="save-button section-save-btn">
                    <FeatherIcon icon="save" size="14" className="nd-icon"/> 저장
                  </Button>
                </div>
              </form>
            {this.store.isApplyDelStoreAccount ?
                <p className="delete-account"><span onClick={e => this.reUseAccount()}>서비스 다시 이용하기</span></p> :
                <p className="delete-account"><span onClick={e => this.applyDelStoreAccount()}>회원탈퇴</span></p>
            }
              </div>
              :
              <p className='empty'>편집할 질문지 템플릿을 선택하시거나 '새로만들기' 버튼을 클릭하세요.</p>
            }

      </div>
    )
  }
}

export default CompanyInfoEdit;
